import { Component, EventEmitter, OnInit, Output, ViewChild, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { Table } from 'primeng/table';
import { ConfirmationService } from 'primeng/api';
import { ClienteService } from '../../../services/clientes.service';
import { ToastService } from '../../../services/toast.service';
import { Cliente } from '../../../models/cliente.model';
import { SeveridadeToast } from '../../../models/enums/severidade-toast.enum';
import { FormatadorHelper } from '../../../helpers/formatador.helper';
import { Router } from '@angular/router';
import { SpinnerService } from '../../../services/spinner.service';
import { Icones } from '../../../shared/variaveisDeRotas';
import { JwtHelper } from '../../../helpers/jwtDecode.helper';
import { retornaDescricao } from '../../../shared/mock/descricao';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-clientes-listagem',
  templateUrl: './clientes-listagem.component.html',
  styleUrls: ['./clientes-listagem.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClientesListagemComponent implements OnInit, OnDestroy {
  @ViewChild('dt') dt: Table | undefined;
  @Output() tituloChange = new EventEmitter<string>();
  @Output() iconeChange = new EventEmitter<string>();

  @Output() tituloDescricao = new EventEmitter<string>();
  @Output() textoDescricao = new EventEmitter<string>();
  @Output() mostrarDescricao = new EventEmitter<boolean>();

  clientes: Cliente[] = [];
  selectedCliente: Cliente | null = null;
  editDialogVisible: boolean = false;
  detailsDialogVisible: boolean = false;
  userId: string;

  private destroy$ = new Subject<void>();

  constructor(
    private clienteService: ClienteService,
    private toastService: ToastService,
    private confirmationService: ConfirmationService,
    private router: Router,
    public spinnerService: SpinnerService,
    private jwtHelper: JwtHelper,
  ) {
    this.userId = this.jwtHelper.getUserIdFromToken();
  }

  ngOnInit(): void {
    this.tituloChange.emit('Listagem de Clientes');
    this.iconeChange.emit(Icones.listaTopicoAmarelo);
    this.tituloDescricao.emit(retornaDescricao('clientes').titulo);
    this.textoDescricao.emit(retornaDescricao('clientes').texto);
    this.mostrarDescricao.emit(true)
    this.loadClientes();
  }

  ngOnDestroy(): void {
    this.mostrarDescricao.emit(false);
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadClientes() {
    this.spinnerService.show('Carregando clientes...');
    this.clienteService.getClientes(this.userId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.clientes = data;
          this.spinnerService.hide();
        },
        error: (e) => {
          console.error('Erro ao carregar clientes:', e);
          this.toastService.setMensagemToast('Erro ao carregar clientes.', SeveridadeToast.Error);
          this.spinnerService.hide();
        }
      });
  }

  openNew() {
    this.router.navigate(['/clientes/adicionar']);
  }

  deleteCliente(cliente: Cliente) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja deletar este cliente?',
      header: 'Confirmar Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.spinnerService.show('Excluindo cliente...');
        this.clienteService.deleteCliente(cliente.id).subscribe({
          next: () => {
            this.toastService.setMensagemToast('Cliente excluído com sucesso.', SeveridadeToast.Success);
            this.loadClientes();
            this.spinnerService.hide();
          },
          error: (e) => {
            console.error('Erro ao excluir cliente:', e);
            this.toastService.setMensagemToast(`Erro ao excluir cliente: ${e.error?.message || 'Erro desconhecido'}`, SeveridadeToast.Error);
            this.spinnerService.hide();
          }
        }).add(() => {
          this.spinnerService.hide();
        });
      },
    });
  }

  viewDetails(cliente: Cliente) {
    this.selectedCliente = cliente;
    this.detailsDialogVisible = true;
  }

  applyFilterGlobal(value: string): void {
    if (this.dt) {
      this.dt.filterGlobal(value, 'contains');
    }
  }

  formatarCpfCnpj(cpfCnpj: string): string {
    return FormatadorHelper.formatarCpfCnpj(cpfCnpj);
  }

  formatarTelefone(telefone: string): string {
    return FormatadorHelper.formatarTelefone(telefone);
  }

  onEditComplete(event: { cliente: Cliente }) {
    this.loadClientes();
    this.editDialogVisible = false;
  }
}
